import * as React from 'react';
import {TextArea} from '@sail/ui';
import {EXAMPLE_TEXT} from './common';

export const Rows = () => (
  <div>
    <div style={{padding: '20px 0'}}>
      <TextArea
        label="Biography (3 rows, default)"
        defaultValue={EXAMPLE_TEXT}
      />
    </div>
    <div style={{padding: '20px 0'}}>
      <TextArea
        label="Biography (6 rows)"
        rows={6}
        defaultValue={EXAMPLE_TEXT}
      />
    </div>
  </div>
);
